<!--  -->
<template>
  <el-form-item
    :label="name"
    :prop="name"
    :rules="rules"
  >
    <el-tooltip
      content="点击上传图片"
      placement="top"
      :disabled="disabled"
    >
      <el-input
        v-model="val"
        :disabled="disabled"
        placeholder="点击上传图片"
        style="width: calc(100% - 30px);"
        @focus="dialogVisible=true"
      />

    </el-tooltip>
    <i class="el-icon-upload" />
    <el-dialog width="500px" :visible.sync="dialogVisible">
      <div class="image-upload-container">
        <el-upload
          action="#"
          :data="{ 'token': token }"
          :accept="accept"
          list-type="picture-card"
          :file-list="previewList"
          :limit="1"
          :http-request="uploadImage"
          :on-remove="handleRemove"
          :on-exceed="handleExceed"
        >
          <template #trigger>
            <div class="h-full trigger-con flex flex-col align-center justify-center">
              <img src="@/assets/list/plus.png" alt="" class="plus-icon">
              <span class="icon-label">上传</span>
            </div>
          </template>
        </el-upload>
        <!--    辅助信息 start    -->
        <span class="tips">
          {{ tips }}
        </span>
        <!--    辅助信息 end    -->
      </div>
    </el-dialog>
  </el-form-item>
</template>

<script>
import { createClient, getSrc } from '@/utils/ik/oss/oss.js'

export default {
  name: 'IkFormImage',
  components: {},
  props: {
    code: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    defaultValue: {
      type: String,
      default: ''
    },
    maxSize: {
      type: Number,
      default: 9999
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fileType: {
      type: Array,
      default: () => []
    },
    tips: {
      type: String,
      default: '请选择本地图片上传'
    },
    require: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      val: '',
      errorSign: false,
      message: '',
      dialogVisible: false,
      listObj: [],
      fileList: [],
      uploadParams: {
        uploadPath: '',
        uploadSize: ''
      },
      client: null,
      imageUrl: '',
      filePath: '',
      previewList: [],
      url: this.$store.getters['setting/getUrl'],
      token: this.$store.getters['user/getToken']
    }
  },
  computed: {
    accept() {
      let res = ''
      for (const i of this.fileType) {
        res = res + i + ','
      }
      return res.slice(0, res.length - 1)
    },
    getRequire() {
      return this.require
    }
  },
  watch: {
    fileList(val, oldVal) {
    },
    value: {
      handler(value, oldValue) {
        if (value !== null || value !== '' || this.val === undefined) {
          this.val = value
        } else {
          this.val = this.defaultValue
        }
        this.click(this.val)
        // 获取地址
        this.getUrl()
      },
      immediate: true
    }
  },
  created() {
    this.client = this.createClient()
  },
  methods: {
    click(value) {
      this.$emit('onFieldChange', this.code, '', value, this.errorSign, this.message)
      this.$emit('input', value)
    },
    isNull() {
      return this.val === '' || this.val === null || this.val === undefined
    },
    reset() {
      this.value = this.defaultValue
    },
    clean() {
      this.value = ''
    },
    createClient() {
      return createClient()
    },
    uploadImage(item) {
      let type
      const client = this.client
      switch (item.file.type) {
        case 'image/jpeg':
          type = 'jpeg'
          break
        case 'image/jpg':
          type = 'jpg'
          break
        case 'image/gif':
          type = 'gif'
          break
        case 'image/png':
          type = 'png'
          break
      }
      const key = 'test/time=' + new Date().getTime() + '&id=' + this.guidGenerator() + '.' + type// 存储路径，并且给图片改成唯一名字
      return client.put(key, item.file, {
        "x-oss-forbid-overwrite": true,
        "Sec-Fetch-Dest": "image",
        "Sec-Fetch-Mode": "no-cors",
        "Sec-Fetch-Site": "cross-site"
      }).then(res => { // OSS上传
        this.val = key
        this.click(this.val)
        this.getUrl()
      })
    },
    guidGenerator() {
      var S4 = function() {
        return ((1 + Math.random()) * 0X10000 | 0).toString(16).substring(1)
      }
      return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4())
    },
    // 新增删除处理方法
    handleRemove() {
      this.previewList = [] // 清空预览列表
      this.val = '' // 清空当前值
      this.click(this.val) // 触发更新
    },

    // 修改getUrl方法：处理空值情况
    getUrl() {
      if (this.val) {
        const client = this.client
        this.uploadParams.uploadPath = getSrc(client, this.val) // 可访问的链接
        this.imageUrl = this.uploadParams.uploadPath
        this.previewList = [{ uid: "1", name: "1", url: this.imageUrl }]
      } else {
        this.previewList = [] // 清空预览
      }
    },
    handleExceed() {
      this.$message.warning('只能上传一张图片')
    }
  }
}
</script>
<style lang="scss" scoped>
.trigger-con {
  .plus-icon {
    width: 20px;
    height: 20px;
    margin-bottom: 10px;
  }

  .icon-label {
    font-family: PingFang SC, PingFang SC, serif;
    font-weight: 400;
    font-size: 14px;
    color: #4E5969;
    line-height: 22px;
    text-align: center;
    font-style: normal;
    text-transform: none;
  }
}

::v-deep .el-upload--picture-card {
  width: 120px;
  height: 120px;
}

::v-deep .el-upload-list--picture-card .el-upload-list__item {
  width: 120px;
  height: 120px;
}

.image-upload-container {
  margin: 0 auto;
  background-color: #F2F3F5;
  padding: 12px;
  width: 408px;
  height: 198px;
  border-radius: 4px 4px 4px 4px;

  .avatar-uploader {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 120px;
    height: 120px;
    margin-bottom: 12px;

    &:hover {
      border-color: #409EFF;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      text-align: center;
    }

    .avatar {
      display: block;
    }
  }

  .tips {
    font-family: PingFang SC, PingFang SC, serif;
    font-weight: normal;
    font-size: 12px;
    color: #86909C;
    line-height: 20px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
}
</style>
